import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { AbstractDetailsComponent } from '../../../../shared/abstracts/details/abstract-details/abstract-details.component';
import { IReference } from '@ahryman40k/ts-fhir-types/lib/R4';
import { ActionSheetController } from '@ionic/angular';
import { TranslatePipe } from '../../../../shared/translate/pipes/translate.pipe';
import { GoalView } from '../../../models/goal.model';
import { stringToGoalView } from '../../../functions/goal.function';

const COLS = [
  { name: 'NAME', colSize: 3 },
  { name: 'VALUE', colSize: 8.3 },
];

@Component({
  selector: 'inc-goal-details',
  templateUrl: './goal-details.component.html',
  styleUrls: ['./goal-details.component.scss'],
})
export class GoalDetailsComponent extends AbstractDetailsComponent<IReference[]> implements OnInit {
  @Output() callDelete = new EventEmitter<IReference>();
  @Output() callUpdate = new EventEmitter<{ data: IReference }>();

  cols = COLS;
  goalViews: GoalView[];

  constructor(private actionSheetController: ActionSheetController, private translatePipe: TranslatePipe) {
    super();
  }

  ngOnInit() {
    this.setGoalViews();
  }

  setGoalViews() {
    this.goalViews = stringToGoalView(this.inData, this.translatePipe);
  }

  delete(data: IReference) {
    this.callDelete.emit(data);
  }

  update(data: IReference) {
    this.callUpdate.emit({ data });
  }

  async openActionSheet(reference: string) {
    const actionSheet = await this.actionSheetController.create({
      buttons: [{
        text: this.translatePipe.transform('EDIT_L'),
        icon: 'create',
        handler: () => { this.update(this.inData.filter(data => data.reference === reference)[0]); }
      },
      {
        text: this.translatePipe.transform('DELETE_L'),
        icon: 'trash',
        handler: () => { this.delete(this.inData.filter(data => data.reference === reference)[0]); }
      }]
    });
    await actionSheet.present();
  }
}
